import React, { useEffect, useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Loader2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL || '';

const CreatorCreate = () => {
  const navigate = useNavigate();
  const [error, setError] = useState(null);

  useEffect(() => {
    const createAndNavigate = async () => {
      try {
        const token = localStorage.getItem('ivisora_auth_token');
        const res = await fetch(`${API_URL}/api/creator/templates`, {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            ...(token ? { Authorization: `Bearer ${token}` } : {}),
          },
        });

        if (!res.ok) {
          const data = await res.json().catch(() => ({}));
          throw new Error(data.detail || 'Failed to create template');
        }

        const template = await res.json();
        navigate(`/editor/${template.id}?creatorMode=1`, { replace: true });
      } catch (err) {
        setError(err.message || 'Something went wrong');
      }
    };

    createAndNavigate();
  }, [navigate]);

  if (error) {
    return (
      <div className="min-h-screen bg-gray-50 flex flex-col items-center justify-center gap-4">
        <p className="text-red-500 text-sm">{error}</p>
        <button
          onClick={() => navigate('/creator/templates')}
          className="text-sm text-violet-600 hover:underline"
        >
          Back to Templates
        </button>
      </div>
    );
  }

  return (
    <div className="min-h-screen bg-gray-50 flex items-center justify-center">
      <Loader2 className="w-8 h-8 text-violet-500 animate-spin" />
    </div>
  );
};

export default CreatorCreate;
